import styled from 'styled-components';

export const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: stretch;
    gap: 16px;
    margin-top: 16px;
`;
